export const roleplayLabels = {
  roleplay_feedback_header: {
    en: 'Your roleplay feedback',
    nl: 'Je rollenspel feedback',
    fr: 'Votre feedback de jeu de rôle',
  },
  roleplay_recap: {
    en: 'Recap',
    nl: 'Samenvatting',
    fr: 'Résumé',
  },
  roleplay_objectives: {
    en: 'Learning objectives',
    nl: 'Leerdoelen',
    fr: "Objectifs d'apprentissage",
  },
  roleplay_standout: {
    en: 'Strong moment',
    nl: 'Sterk moment',
    fr: 'Moment fort',
  },
  roleplay_tip: {
    en: 'Tip to take away',
    nl: 'Tip om mee te nemen',
    fr: 'Conseil à retenir',
  },
  /* The whole debrief card when the user barely took part: nothing was rated. */
  roleplay_not_taken_part: {
    en: "The conversation didn't really get going, so there is nothing to rate yet. Feel free to try again when you're ready.",
    nl: 'Het gesprek kwam niet echt op gang, dus er valt nog niets te beoordelen. Probeer het gerust opnieuw wanneer je er klaar voor bent.',
    fr: "La conversation n'a pas vraiment démarré, il n'y a donc encore rien à évaluer. N'hésitez pas à réessayer quand vous serez prêt.",
  },
  roleplay_practise_again: {
    en: 'Practise again',
    nl: 'Opnieuw oefenen',
    fr: "S'entraîner à nouveau",
  },
  roleplay_feedback_prompt: {
    en: "We're curious — how useful did you find this exercise? What could be even better?",
    nl: 'Benieuwd, hoe nuttig vond je deze oefening? Wat kan er eventueel nog beter?',
    fr: "Cela nous intéresse : à quel point cet exercice vous a-t-il été utile ? Qu'est-ce qui pourrait être amélioré ?",
  },
  roleplay_title: {
    en: 'Practice Conversation',
    nl: 'Oefengesprek',
    fr: "Conversation d'entraînement",
  },
  roleplay_scenario: {
    en: 'Scenario',
    nl: 'Scenario',
    fr: 'Scénario',
  },
  roleplay_what_youll_practice: {
    en: "What you'll practice",
    nl: 'Wat je gaat oefenen',
    fr: 'Ce que vous allez pratiquer',
  },
  roleplay_begin: {
    en: 'Start conversation',
    nl: 'Start gesprek',
    fr: 'Démarrer la conversation',
  },
  roleplay_talking_to: {
    en: "You're talking to",
    nl: 'Je praat met',
    fr: 'Vous parlez à',
  },
  roleplay_think_about: {
    en: 'Think about',
    nl: 'Denk aan',
    fr: 'Pensez à',
  },
  roleplay_end: {
    en: 'End Roleplay',
    nl: 'Beëindig rollenspel',
    fr: 'Terminer le jeu de rôle',
  },
  roleplay_end_and_get_feedback: {
    en: 'End & get feedback',
    nl: 'Afronden & feedback ontvangen',
    fr: 'Terminer & recevoir le feedback',
  },
  roleplay_keep_going: {
    en: 'Keep going',
    nl: 'Doorgaan',
    fr: 'Continuer',
  },
  roleplay_generating_feedback: {
    en: 'Generating your feedback...',
    nl: 'Je feedback wordt gegenereerd...',
    fr: 'Génération de votre feedback…',
  },
  roleplay_your_feedback: {
    en: 'Your Feedback',
    nl: 'Jouw feedback',
    fr: 'Votre feedback',
  },
  roleplay_standout_moment: {
    en: 'Strong Moment',
    nl: 'Sterk moment',
    fr: 'Moment fort',
  },
  roleplay_tip_to_takeaway: {
    en: 'Tip to Take Away',
    nl: 'Tip om mee te nemen',
    fr: 'Conseil à retenir',
  },
  roleplay_practicing_10min: {
    en: "You've been practicing for 10 minutes.",
    nl: 'Je oefent al 10 minuten.',
    fr: 'Vous pratiquez depuis 10 minutes.',
  },
  roleplay_ready_to_wrap_up: {
    en: 'Ready to wrap up and get your feedback?',
    nl: 'Klaar om af te ronden en je feedback te ontvangen?',
    fr: 'Prêt·e à conclure et à recevoir votre feedback ?',
  },
  roleplay_feedback_sent: {
    en: 'Your feedback has been sent to Wundo.',
    nl: 'Je feedback is naar Wundo gestuurd.',
    fr: 'Votre feedback a été envoyé à Wundo.',
  },
  roleplay_suggest_end: {
    en: "You've covered your learning objectives. Ready to wrap up?",
    nl: 'Je hebt je leerdoelen behandeld. Klaar om af te ronden?',
    fr: "Vous avez abordé vos objectifs d'apprentissage. Prêt·e à conclure ?",
  },
  roleplay_conversation_with: {
    en: 'Conversation with',
    nl: 'Gesprek met',
    fr: 'Conversation avec',
  },
  roleplay_type_response: {
    en: 'Type your response...',
    nl: 'Typ je antwoord...',
    fr: 'Tapez votre réponse…',
  },
  roleplay_conversation_starting: {
    en: 'The conversation will begin shortly...',
    nl: 'Het gesprek begint zo...',
    fr: 'La conversation va commencer...',
  },
  roleplay_loading: {
    en: 'Loading roleplay...',
    nl: 'Rollenspel laden...',
    fr: 'Chargement du jeu de rôle...',
  },
  roleplay_chat_description: {
    en: 'Text-based conversation',
    nl: 'Tekstgesprek',
    fr: 'Conversation textuelle',
  },
  roleplay_coming_soon: {
    en: 'Coming soon',
    nl: 'Binnenkort beschikbaar',
    fr: 'Bientôt disponible',
  },
  roleplay_voice_description: {
    en: 'Spoken',
    nl: 'Gesproken',
    fr: 'Parlé',
  },
  roleplay_recommended: {
    en: 'Recommended',
    nl: 'Aanbevolen',
    fr: 'Recommandé',
  },
  voice_connecting: {
    en: 'Connecting...',
    nl: 'Verbinden...',
    fr: 'Connexion...',
  },
  voice_disconnected: {
    en: 'Disconnected',
    nl: 'Verbinding verbroken',
    fr: 'Déconnecté',
  },
  voice_end_call: {
    en: 'End call',
    nl: 'Gesprek beëindigen',
    fr: "Terminer l'appel",
  },
  voice_mute: {
    en: 'Mute',
    nl: 'Dempen',
    fr: 'Couper le son',
  },
  voice_unmute: {
    en: 'Unmute',
    nl: 'Ontdempen',
    fr: 'Réactiver le son',
  },
  voice_captions: {
    en: 'Captions',
    nl: 'Ondertiteling',
    fr: 'Sous-titres',
  },
  voice_device_settings: {
    en: 'Device settings',
    nl: 'Apparaatinstellingen',
    fr: 'Paramètres audio',
  },
  voice_is_speaking: {
    en: 'is speaking...',
    nl: 'spreekt...',
    fr: 'parle...',
  },
  voice_listening: {
    en: 'Listening...',
    nl: 'Luisteren...',
    fr: 'Écoute...',
  },
  voice_setup_title: {
    en: 'Check your audio',
    nl: 'Controleer je audio',
    fr: 'Vérifiez votre audio',
  },
  voice_setup_subtitle: {
    en: 'Select your microphone and speaker before joining.',
    nl: 'Kies je microfoon en speaker voordat je deelneemt.',
    fr: 'Sélectionnez votre micro et votre haut-parleur avant de rejoindre.',
  },
  voice_join_call: {
    en: 'Join call',
    nl: 'Deelnemen',
    fr: 'Rejoindre',
  },
  voice_microphone: {
    en: 'Microphone',
    nl: 'Microfoon',
    fr: 'Microphone',
  },
  voice_speaker: {
    en: 'Speaker',
    nl: 'Luidspreker',
    fr: 'Haut-parleur',
  },
  voice_connect_failed_title: {
    en: 'Voice connection failed',
    nl: 'Spraakverbinding mislukt',
    fr: 'Échec de la connexion vocale',
  },
  voice_connect_failed_body: {
    en: 'Check your internet connection and try again.',
    nl: 'Controleer je internetverbinding en probeer opnieuw.',
    fr: 'Vérifiez votre connexion internet et réessayez.',
  },
  voice_mic_permission_title: {
    en: 'Microphone access blocked',
    nl: 'Geen toegang tot microfoon',
    fr: 'Accès au microphone bloqué',
  },
  voice_mic_permission_body: {
    en: 'Enable microphone access for your browser in iOS Settings → Privacy & Security → Microphone, then reload and try again.',
    nl: 'Geef je browser toegang tot de microfoon via Instellingen → Privacy & Beveiliging → Microfoon, herlaad de pagina en probeer opnieuw.',
    fr: "Activez l'accès au microphone pour votre navigateur dans Réglages iOS → Confidentialité & Sécurité → Microphone, puis rechargez la page.",
  },
  voice_try_again: {
    en: 'Try again',
    nl: 'Probeer opnieuw',
    fr: 'Réessayer',
  },
  roleplay_unable_to_load: {
    en: 'Unable to load',
    nl: 'Laden mislukt',
    fr: 'Impossible de charger',
  },
  roleplay_aborted_title: {
    en: 'Roleplay ended',
    nl: 'Rollenspel beëindigd',
    fr: 'Jeu de rôle terminé',
  },
  roleplay_aborted_body: {
    en: "You ended this roleplay before the conversation started, so there's nothing to give feedback on. Start a new roleplay whenever you're ready to practice.",
    nl: 'Je hebt dit rollenspel beëindigd voordat het gesprek begon, dus er is niets om feedback op te geven. Start een nieuw rollenspel zodra je klaar bent om te oefenen.',
    fr: "Vous avez terminé ce jeu de rôle avant que la conversation ne commence, il n'y a donc rien à commenter. Lancez un nouveau jeu de rôle dès que vous êtes prêt·e à vous entraîner.",
  },
} as const satisfies Record<string, Record<string, string>>;
